import { supportedIcons } from './CreateNewPipeline';
import { Pipeline } from '../../../store/data/types';
import { v4 as uuidv4 } from 'uuid';
import readJson from '../../../shared/jsonReader/jsonReader';
import clone from 'just-clone';
import { AddPipelineType } from './types';

export const validate = (addData: AddPipelineType | undefined): boolean => {
  if (!addData || !addData.name) {
    return false;
  }
  if ('icon' in addData) {
    return supportedIcons.includes(addData.icon);
  }
  if ('file' in addData) {
    return Boolean(addData.file);
  }
  if ('pipeline' in addData) {
    return Boolean(addData.pipeline);
  }
  return false;
};

export const preparePipelines = async (
  addData: AddPipelineType,
  pipelines: Pipeline[] | undefined,
  user: string | undefined
): Promise<Pipeline> => {
  if (!user) {
    throw new Error('Not authenticated');
  }
  const uuid = uuidv4();
  if ('icon' in addData) {
    return {
      user: user,
      pid: uuid,
      pipeline: {
        name: addData.name,
        icon: addData.icon,
        services: {},
      },
      graph: {
        nodes: [],
        edges: [],
      },
    };
  }
  if ('file' in addData) {
    const file = addData.file;
    if (file === null) {
      throw new Error('No file given');
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const fileParsed: Pipeline = await readJson(addData.file);
    fileParsed.pid = uuid;
    fileParsed.user = user;
    fileParsed.pipeline.name = addData.name;
    return fileParsed;
  }
  if ('pipeline' in addData) {
    const filtered = pipelines?.filter(e => e.pid === addData.pipeline);
    if (!filtered) {
      throw new Error('Pipeline not available');
    }
    const newPipeline = clone(filtered[0]);
    newPipeline.pid = uuid;
    newPipeline.user = user;
    newPipeline.pipeline.name = addData.name;
    return newPipeline;
  }
  throw new Error('Should not happen');
};
